module.exports = __webpack_public_path__ + "img/galeria-captores-1.a342363d.png";